import { render, staticRenderFns } from "./DetailsHeader.vue?vue&type=template&id=34b7d6a9&"
import script from "./DetailsHeader.vue?vue&type=script&lang=js&"
export * from "./DetailsHeader.vue?vue&type=script&lang=js&"
import style0 from "./DetailsHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports